import { JobLog } from '../../models/jobLog';

export enum TryFetchLogInfoStatus {
  NotStartedYet,
  InProgress,
  Succeeded,
  Failed,
}

export enum FailureType {
  None,
  LogNotFound,
  NotSharedWithUser,
  ShareExpired,
  Unexpected,
}

export interface TryFetchLogInfoState {
  status: TryFetchLogInfoStatus;
  failureType: FailureType;
  logInfo: JobLog | undefined;
}

export type AxiosResponseStatus = number | undefined;
